import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {EventEmitter} from '@angular/forms/src/facade/async';
import {Router} from '@angular/router';
import {AuthenticationService} from 'app/pages/login/authentication.service';
import {constant} from 'app/app.constants';
import {Location} from '@angular/common';
import {secondsToMins} from '../../../utils/helpers';
import {ComplianceService} from '../../../core/services/compliance.service';
import {T2CardComponent} from '../t2-card/t2-card.component';
import {SweetAlertHelper} from 'app/core/helpers/sweet-alert-helper.service';
import { UsersService } from '../../../pages/users/users.service';
import { TripNotificationsService } from 'app/services/trip-notifications.service';

declare const jQuery: any;
declare const html2canvas: any;

@Component({
  selector: 'app-t2-template-basic',
  templateUrl: './t2-template-basic.component.html',
  styleUrls: ['./t2-template-basic.component.scss']
})
export class T2TemplateBasicComponent implements OnInit, AfterViewInit, OnDestroy {

  private inactivityTimer: any;
  private inactivityTime = 0;
  private claimDenials = 0;
  private inactivityTimeFormat = ' 00:00';
  private uid = this.getRandomArbitrary();
  hide: boolean;
  public activeCompliance: boolean;
  @Output() EmitterAction: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('btnRequestSupport') btnRequestSupport: ElementRef;
  @ViewChild('btnCounting') btnCounting: ElementRef;
  @ViewChild('btnTraining') btnTraining: ElementRef;
  @ViewChild('cardCompliance') cardCompliance: T2CardComponent;
  @ViewChild('screenShotModal') screenShotModal: T2CardComponent;
  @ViewChild('imageTag') imageTag: ElementRef;

  private currenUser = JSON.parse(localStorage.getItem('currentUser'));
  public userType: boolean = JSON.parse(localStorage.getItem('currentUser')).usertypeid;

  isWebApp = JSON.parse(localStorage.getItem('isWebApp'));

  isHs = JSON.parse(localStorage.getItem('isHs')) === true;

  imgData: any = null;
  description = '';

  constructor(
    private router: Router,
    private location: Location,
    private authService: AuthenticationService,
    private complianceService: ComplianceService,
    private sweetAlertHelper: SweetAlertHelper,
    private userService: UsersService,
    private tripNotificationsService: TripNotificationsService
  ) {

    // Inactivity Controlvar t;
    if (localStorage.getItem('timer')) {
      let t = JSON.parse(localStorage.getItem('timer'));
      t.push(this.uid);
      localStorage.setItem('timer', JSON.stringify(t));
    } else {
      localStorage.setItem('timer', JSON.stringify([this.uid]));
    }

     if (JSON.parse(localStorage.getItem('timer'))[0] === this.uid) {
      this.initializeTimer();
     }
     document.addEventListener('click', () => {
       this.inactivityTime = 0;
       localStorage.setItem('time', `${this.inactivityTime}`);
       this.inactivityTimeFormat = secondsToMins(this.inactivityTime);
     });
     document.addEventListener('keyup', () => {
      this.inactivityTime = 0;
      localStorage.setItem('time', `${this.inactivityTime}`)
       this.inactivityTimeFormat = secondsToMins(this.inactivityTime);
     });

     window.addEventListener("storage", this.storageEventListener.bind(this));
      /*this.verifyCompliances();*/
   }

   private storageEventListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      if (event.key === 'time') {
        let v;
        try { v = JSON.parse(event.newValue); }
        catch (e) { v = event.newValue; }
        this.inactivityTime = v;
        this.inactivityTimeFormat = secondsToMins(this.inactivityTime);
        if (this.validateMaxLive()) {
          this.logout();
        }
      }

      if (event.key === 'timer') {
        let v;
        try { v = JSON.parse(event.newValue); }
        catch (e) { v = event.newValue; }
        if (v) {
          if (v[0] === this.uid) {
            this.initializeTimer();
          }
        }
      }
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    if (localStorage.getItem('timer')) {
      let t = JSON.parse(localStorage.getItem('timer'));
      if (t.length === 1) {
        localStorage.removeItem('timer');
        return;
      }

      let i = t.indexOf(this.uid);
      if (i !== -1) {
        t.splice(i, 1);
        localStorage.setItem('timer', JSON.stringify(t));
      }
    }
  }

  private sendCurrentUserInformationToChild(): void {
    this.userService.getUserProfile()
      .subscribe({
        next: (currentUserData) => this.userService.sendCurrentUserInformation(currentUserData)
      }
    );
  }

  private logout() {
    this.tripNotificationsService.closeSignalR();
    this.authService.logout().subscribe();
    localStorage.removeItem('currentUser');
      localStorage.removeItem('timer');
      this.sweetAlertHelper.createCustomAlert({
        title: 'Inactivity',
        text: 'Your session has been closed due to inactivity',
        type: 'info'
      })
      this.router.navigate(['/login'], { replaceUrl: true });
      this.location.replaceState('/login');
  }

  private initializeTimer() {
    if (this.inactivityTimer) {
      clearInterval(this.inactivityTimer);
    }
    // localStorage.setItem('timer', 'initialized');
    this.inactivityTimer = setInterval(() => {
      this.inactivityTime++;
      localStorage.setItem('time', `${this.inactivityTime}`);
      this.inactivityTimeFormat = secondsToMins(this.inactivityTime);
        if (this.validateMaxLive()) {
        clearInterval(this.inactivityTimer);
        this.logout();
      }
    }, 1000);
  }

  private getRandomArbitrary() {
    return Math.random() * (1 - 999999) + 1;
  }

  private validateMaxLive() {
    return this.inactivityTime === constant.MAX_INACTIVITY_MINS * 60;
  }

  ngOnInit(): void {
    this.sendCurrentUserInformationToChild();
  }

  ngOnDestroy() {
    localStorage.removeItem('time');
    localStorage.removeItem('timer');
    clearInterval(this.inactivityTimer);
  }

  ngAfterViewInit(): void {
    jQuery(this.btnRequestSupport.nativeElement)
      .draggable({
        // containment: 'body',
        containment: [0, 0, window.innerWidth - 300, 20],
        stop: (event) => {
          window.localStorage.setItem(
            'position-btn-support',
            JSON.stringify({
              'left': event.target.offsetLeft,
              'top': event.target.offsetTop
            })
          );
        }
      });
    jQuery(this.btnCounting.nativeElement)
      .draggable({
        // containment: 'body',
        containment: [0, 0, window.innerWidth - 300, 20],
        stop: (event) => {
          window.localStorage.setItem(
            'position-btn-training',
            JSON.stringify({
              'left': event.target.offsetLeft,
              'top': event.target.offsetTop
            })
          );
        }
      });

  }


  /**
   * @name toogleMenu
   * @description Funcion para ocultar y ver el muenu principal
   * @param event
   * @return object EventEmitter
   */
  toogleMenu (event) {
    if (window.innerWidth <= 900) {
      this.hide = !this.hide;
      window.localStorage.setItem('hideMenu', this.hide ? 'hide' : 'visible');
      return this.EmitterAction.emit({
        isHide: this.hide,
        localStorageKey: 'hideMenu',
        event: event
      });
    } else {
      this.router.navigate([window.localStorage.getItem('defaultModule')]);
    }
  }
  openTraining()
  {
    if(this.isHs) {
      window.open('https://s3.amazonaws.com/trip-images/eec6754c-6e6c-42df-a6e7-a3dafc2282f3?636988713946736609');
    } else {
      window.open('https://s3.amazonaws.com/trip-images/87259838-40d8-4ead-936b-a8171a591bc5?636940454511575658', '_blank');
    }
  }

  /**@name verifyCompliances
   * @description si es type 2 Trae del servicio si tiene compliances.
   */
  verifyCompliances() {
    const type: number = JSON.parse(localStorage.getItem('currentUser')).usertypeid;
    if (type === 2) {
      this.complianceService.getActive().subscribe(
        (active: boolean) => {
            this.activeCompliance = active;
        },
        error => {
        }
      );
      this.complianceService.getClaims().subscribe(
        claims => {
          this.claimDenials = claims;
        },
        error => {
        }
        );
    }
  }

  catchCapture(event: any): void {
    html2canvas(document.body, {
      scale: 3,
      imageTimeout: 5000
    }).then((canvas: any) => {
      const imgData = canvas.toDataURL('image/jpeg', 0.40);
      this.imgData = imgData;
      this.screenShotModal.open();
    });
  }

  closeModal(): void {
    this.screenShotModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-template-basic/t2-template-basic.component.ts